import { Notification } from './../models/notification.model';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ID } from '../models/ID.model';

@Injectable({
    providedIn: 'root'
})
export class NotificationsService {

    constructor(
        private http: HttpClient
    ) { }

    getNotifications(page: number, itemsPerPage: number, incluirLeidas: boolean = false) {
        const headers = {
                'page-number': String(page),
                'page-size': String(itemsPerPage)
        };
        return this.http.get<Notification[]>(`/notificaciones`, { observe: 'response', headers, params: { 'incluir-leidas': String(incluirLeidas) } });
    }

    getNotificationCount() {
        return this.http.get<number>(`/notificaciones/no-leidas`);
    }

    getNotificationById(id: ID) {
        return this.http.get<Notification>(`/notificaciones/${id}`);
    }
}
